export default {
    title: 'Configuración del Modelo de IA',
    permissionAlert: 'Esta página solo puede ser modificada por administradores. Las Claves API están encriptadas y administradas por administradores del sistema en el backend; esta página solo controla los interruptores del lado del negocio y la selección de modelos.',
    providerSection: 'Configuración General de Modelos',
    imageModelSection: 'Configuración de Modelo de Imagen',
    taskSection: 'Asignación de Modelo por Tarea',
    taskDesc: 'Asigne modelos a diferentes tareas de IA',
    usageSection: 'Estadísticas de Uso (Este Mes)',
    connected: '● Conectado',
    notConnected: '○ No Conectado',
    connectionStatus: 'Estado de Conexión',
    errorStatus: 'Error',
    unknownStatus: 'Desconocido',
    errorHint: 'Error de conexión de API, contacte al administrador del sistema',
    connectedStatus: 'Conectado',
    notConnectedStatus: 'No Conectado',
    availableModels: 'Modelos Disponibles',
    checkHint: 'Los modelos marcados se pueden usar en tareas de IA',
    notConnectedHint: 'Contacte al administrador del sistema para completar la integración de API',
    recommended: 'Recomendado',
    adminOnlyTooltip: 'Solo para administrador',
    toggleFailed: 'Operación fallida, intente nuevamente',
    saveOk: 'Configuración guardada',
    noModels: 'No hay modelos disponibles aún',
    modelConfigNotFound: 'Configuración del modelo no encontrada, actualice e intente nuevamente',
    configServiceUnavailable: 'El servicio de configuración de IA no está disponible, intente más tarde',
    provider: {
      anthropic: 'Anthropic (Claude)',
      openai: 'OpenAI (GPT)',
      google: 'Google (Gemini)',
    },
    task: {
      name: 'Tarea',
      desc: 'Descripción',
      primary: 'Modelo Principal',
      backup: 'Modelo de Respaldo',
      noBackup: 'Sin Respaldo',
      random: 'Rotación Circular',
      primaryRequired: 'Configure primero el modelo principal',
      articleGen: '📝 Generación de Artículos',
      articleGenDesc: 'Artículo completo + Preguntas Frecuentes + Meta',
      keywordMining: '🔑 Minería de Palabras Clave',
      keywordMiningDesc: 'Descubrimiento de palabras clave por IA',
      scoring: 'Puntuación SEO/GEO',
      scoringDesc: 'Puntuación asistida por IA',
    },
    usage: {
    title: 'Estadísticas de Uso de IA (Este Mes)',
    callCount: 'Llamadas API',
    totalTokens: 'Uso de Tokens',
    cost: 'Costo Mensual',
    dataSourceStub: 'Los datos son un marcador de posición, pendiente de integración con ES',
    byModelTitle: 'Por Modelo',
    modelName: 'Modelo',
    provider: 'Proveedor',
    callCountCol: 'Llamadas',
    costCol: 'Costo (USD)',
  },
    backupHint: '✓ Modelo de Respaldo: cambia automáticamente al respaldo cuando el principal falla (límite de velocidad / saldo insuficiente / tiempo de espera agotado). Límite Diario: pausa la tarea cuando se alcanza el conteo de llamadas diarias para prevenir costos descontrolados.',
};
